export const baseUrl = '/customer-orders'
